// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* custom button css */
/* Falls back through the original --Colors-UI-* variables (still the default
   everywhere this component is used) so a dev-tool dark theme can hook in via
   --bg-secondary/--bg-hover/--text-secondary/--text-primary/--accent-color
   without changing anything for existing (non-dev-tool) usages. */
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  border-radius: 8px;
  width: auto;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 8px;
  padding-right: 8px;
  background: var(--bg-secondary, var(--Colors-UI-Neutral-Grey-100, #F5F5F5));
  color: var(--text-secondary, #808080);
}
.container:hover {
  background: var(--bg-hover, var(--Colors-UI-Primary-Primary-Medium, #E6F2FF));
}
.container:active {
  background: var(--bg-hover, #E0E8F0);
  transform: scale(0.95);
  filter: brightness(0.92);
}
.container.selected {
  background: var(--bg-hover, #D9ECFA);
  color: var(--accent-color, #113E57);
}
.container.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
.icon {
  height: 24px;
  width: 24px;
  padding: 4px;
}
.title {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  color: var(--text-primary, #4E758E);
  white-space: nowrap;
  user-select: none;
  padding-left: 8px;
  padding-right: 8px;
}

/* Icon-only buttons (e.g. refresh \\u21bb) \\u2014 a circular, fixed-size button reads
   as an intentional icon button rather than an oddly-shrunk text pill. */
:host(.ps-icon-btn) .container {
  min-width: 32px;
  min-height: 32px;
  padding: 0;
  border-radius: 50%;
}
:host(.ps-icon-btn) .title {
  font-size: 20px;
  padding-left: 0;
  padding-right: 0;
}
`, "",{"version":3,"sources":["webpack://./src/toolbar-button.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;;;kEAGkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,2EAA2E;EAC3E,qCAAqC;AACvC;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;yEACyE;AACzE;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["/* custom button css */\n/* Falls back through the original --Colors-UI-* variables (still the default\n   everywhere this component is used) so a dev-tool dark theme can hook in via\n   --bg-secondary/--bg-hover/--text-secondary/--text-primary/--accent-color\n   without changing anything for existing (non-dev-tool) usages. */\n.container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  cursor: pointer;\n  border-radius: 8px;\n  width: auto;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  padding-left: 8px;\n  padding-right: 8px;\n  background: var(--bg-secondary, var(--Colors-UI-Neutral-Grey-100, #F5F5F5));\n  color: var(--text-secondary, #808080);\n}\n.container:hover {\n  background: var(--bg-hover, var(--Colors-UI-Primary-Primary-Medium, #E6F2FF));\n}\n.container:active {\n  background: var(--bg-hover, #E0E8F0);\n  transform: scale(0.95);\n  filter: brightness(0.92);\n}\n.container.selected {\n  background: var(--bg-hover, #D9ECFA);\n  color: var(--accent-color, #113E57);\n}\n.container.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n  cursor: not-allowed;\n}\n.icon {\n  height: 24px;\n  width: 24px;\n  padding: 4px;\n}\n.title {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n  color: var(--text-primary, #4E758E);\n  white-space: nowrap;\n  user-select: none;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n/* Icon-only buttons (e.g. refresh \\u21bb) \\u2014 a circular, fixed-size button reads\n   as an intentional icon button rather than an oddly-shrunk text pill. */\n:host(.ps-icon-btn) .container {\n  min-width: 32px;\n  min-height: 32px;\n  padding: 0;\n  border-radius: 50%;\n}\n:host(.ps-icon-btn) .title {\n  font-size: 20px;\n  padding-left: 0;\n  padding-right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
